import { createFileRoute } from '@tanstack/react-router';
import { routeContracts } from '@/app/router/routeContracts';

export const Route = createFileRoute('/planner-calendar')({
  component: routeContracts.plannerCalendar.component,
});
